initPostHog()

function initPostHog(){
  try{
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init Ie Ts Ms Ee Es Rs capture Ge calculateEventProperties Os register register_once register_for_session unregister unregister_for_session js getFeatureFlag getFeatureFlagPayload isFeatureEnabled reloadFeatureFlags updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures on onFeatureFlags onSurveysLoaded onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey canRenderSurveyAsync identify setPersonProperties group resetGroups setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags reset get_distinct_id getGroups get_session_id get_session_replay_url alias set_config startSessionRecording stopSessionRecording sessionRecordingStarted captureException loadToolbar get_property getSessionProperty Ds Fs createPersonProfile Ls Ps opt_in_capturing opt_out_capturing has_opted_in_capturing has_opted_out_capturing clear_opt_in_out_capturing Cs debug I As getPageViewId captureTraceFeedback captureTraceMetric".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    posthog.init('phc_CfiaZYdfbMzrkcjHqSaEjRgeA6nkXDOHC1hECtI1xQ3', {
        api_host: 'https://us.i.posthog.com',
        defaults: '2025-05-24',
        person_profiles: 'always',
        capture_pageview: true,
        capture_pageleave: true,
        autocapture: false
    })
    console.log("[PostHog] Successfully initialized!")
    document.addEventListener('DOMContentLoaded', () => {
      return console.log('[PostHog] ALL Manual capture disabled')
      initPostHogEmailCollector()
      initPostHogAddToCartFormSubmitEvent()
      initPostHogAddToCartQuickAddEvent()
      initPostHogAddToCartEvent()
      initPostHogAddToCartShopPayEvent()
      initPostHogChangeCartVariantChangeEvent()
      initPostHogRemoveFromCartEvent()
    })
  } catch(error){
    console.error("[PostHog] Error in initialization:", error)
  }
}

function initPostHogAddToCartQuickAddEvent(){
  console.log("[PostHog] Now tracking add to cart quick add events.")
  document.querySelectorAll('.product-card__quick-add-button').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      let quantity = 1
      const quantityValue = btn.parentElement.querySelector('input[name="quantity"]')?.value
      if(!!quantityValue){
        quantity = Number(quantityValue)
        if(isNaN(quantity)) quantity = 1
      }

      let product_id = null
      const product_idValue = btn.parentElement.querySelector('input[name="product-id"]')?.value
      if(!!product_idValue){
        product_id = String(product_idValue)
      }
      
      posthog.capture('Clicked Add To Cart Quick-Add Button', {
        product_id,
        quantity
      })
    })
  })
}

function initPostHogAddToCartEvent(){
  console.log("[PostHog] Now tracking add to cart events.")
  document.querySelectorAll('buy-buttons > button').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      let quantity = 1
      const quantityValue = btn.parentElement.parentElement.querySelector('input[name="quantity"]')?.value
      if(!!quantityValue){
        quantity = Number(quantityValue)
        if(isNaN(quantity)) quantity = 1
      }

      let product_id = null
      const product_idValue = btn.parentElement.parentElement.querySelector('input[name="product-id"]')?.value
      if(!!product_idValue){
        product_id = String(product_idValue)
      }
      
      posthog.capture('Clicked Add To Cart Button', {
        product_id,
        quantity
      })
    })
  })
}

function initPostHogAddToCartShopPayEvent(){
  console.log("[PostHog] Now tracking add to cart Shop pay events.")
  document.querySelectorAll('shop-pay-wallet-button').forEach((btn) => {
    btn.addEventListener('click', (event) => {
      let quantity = 1
      const quantityValue = btn.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[name="quantity"]')?.value
      if(!!quantityValue){
        quantity = Number(quantityValue)
        if(isNaN(quantity)) quantity = 1
      }

      let product_id = null
      const product_idValue = btn.parentElement.parentElement.parentElement.parentElement.parentElement.querySelector('input[name="product-id"]')?.value
      if(!!product_idValue){
        product_id = String(product_idValue)
      }
      
      posthog.capture('Clicked Add To Cart "Shop Pay" Button', {
        product_id,
        quantity
      })
    })
  })
}

function initPostHogAddToCartFormSubmitEvent(){
  console.log("[PostHog] Now tracking add to cart form submissions.")
  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const formData = new FormData(form);
      const formDataObject = Object.fromEntries(formData.entries());
      
      posthog.capture('Submitted Add To Card Form', {
        form_id: formDataObject.id,
        product_id: formDataObject['product-id'],
        quantity: Number(formDataObject.quantity)
      })
    })
  })
}

function initPostHogChangeCartVariantChangeEvent(){
  console.log("[PostHog] Now tracking cart variant change events.")
  document.querySelectorAll('.variant-picker__option-values > a').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      let product_id = null
      const product_idValue = document.querySelector('input[name="product-id"]')?.value
      if(!!product_idValue){
        product_id = String(product_idValue)
      }
      
      let new_variant = null
      const new_variantValue = anchor.querySelector('span')?.innerText
      if(!!new_variantValue) {
        new_variant = new_variantValue
      }
      posthog.capture('Changed Product Variant', {
        new_variant,
        product_id
      })
    })
  })
}

function initPostHogRemoveFromCartEvent(){
  console.log("[PostHog] Now tracking cart removal events.")
  document.querySelectorAll('.order-summary__body > tr > td:nth-of-type(2) a').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.href
      let product_id = null
      const product_idValue = href?.split('?id=')[1]?.split(':')[0]
      if(!!product_idValue){
        product_id = String(product_idValue)
      }
      
      let new_quantity = null
      const new_quantityValue = href?.split('quantity=')[1]?.split('&')[0]
      if(!!new_quantityValue) {
        new_quantity = Number(new_quantityValue)
        if(isNaN(new_quantity)) new_quantity = null
      }

      let removed_item = false
      if(new_quantity === 0){
        removed_item = true
      }
      
      posthog.capture('Changed Product Cart Quantity', {
        new_quantity,
        product_id,
        removed_item
      })
    })
  })
}

function initPostHogEmailCollector() {
  setTimeout(() => {
    console.log("[PostHog] Now tracking email change events.")
    document.querySelectorAll('[type="email"]').forEach((anchor) => {
      anchor.addEventListener('blur', (event) => {
        const email = event.target.value
        if(email){
          posthog.identify(posthog.get_distinct_id(), {
            email
          })
        }
      })
    })
  }, 1000)
}
